import { Injectable } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { AcessoApiService } from '../../../acessoApi.service'
import { error } from "util";
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router'


@Injectable()
export class CurriculoService{

    constructor(private acessoAPI: AcessoApiService, private notificacao: NotificationsService, private routes: Router ){}
public codCand: any;
public mensagem: any
public arrayInfos: any

emitirNovaCategoria = new EventEmitter();


    setCodCand(codCand: number): void{
        this.codCand = codCand
    }




    recuperarCodCand(): any{
        return this.codCand;
    }


}


// WEBPACK FOOTER //
// ./src/app/pages/administracao/curriculo/curriculo.service.ts